import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete } from '@totalsoft/rocket-ui';
import { IconButton, Tooltip } from '@mui/material';
import { useClientQuery } from 'hooks/apollo';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { PERSON_LIST_QUERY } from '../io';
import { useTranslation } from 'react-i18next';

const PersonAutocomplete = ({ label, disabled, helperText, error, value, onChange, onAdd, adding }) => {
  const clientQuery = useClientQuery();
  const { t } = useTranslation();

  const filterOptions = useCallback(
    async value => {
      const inputText = value?.toString() || '';
      if (!inputText) return [];

      const { data } = await clientQuery(PERSON_LIST_QUERY, {
        variables: { search: inputText }
      });
      if (!data) return [];
      const opts = data.personList;
      return opts;
    },
    [clientQuery]
  );

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
      <Autocomplete
        id='person-selection-autocomplete'
        label={label}
        value={value}
        onChange={onChange}
        loadOptions={filterOptions}
        error={error}
        helperText={helperText}
        disabled={disabled}
        noOptionsText='Start typing to search for a person'
        fullWidth
      />
      <Tooltip placement='top' arrow title={t(adding ? 'Cancel' : 'Users.AddNewPerson')}>
        <IconButton aria-label='add' size='small' onClick={onAdd}>
          {adding ? <CloseIcon fontSize='inherit' color='error' /> : <AddIcon fontSize='inherit' color='primary' />}
        </IconButton>
      </Tooltip>
    </div>
  );
};

PersonAutocomplete.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  adding: PropTypes.bool.isRequired
};

export default PersonAutocomplete;
